import React, { useEffect, useState } from 'react'
import NavBar from "../componets/General/NavBar"
import Footer from "../componets/General/Footer"
import axios from 'axios'
import '../style/clima.css'
import { Alert } from 'react-bootstrap'
const Clima = () =>{

    const [input,setInput] = useState("");
    const [data,setData] = useState(null);
    const [error,setError] = useState(false);

    const HandleChange = e =>{
         
        setInput(e.target.value)
    }
    useEffect(()=>{
        window.scrollTo(0,0);
    },[])
 
    const ApiConection = async() =>{
        // let output = "";
        // let error = "";
        // let file = "";
        if(input.length > 0){
            
            let linkApi = "https://api.openweathermap.org/data/2.5/weather?q=" + decodeURIComponent(input) + "&appid=449ebd0e6b0348db5860ef308da3f95d";
            await axios.get(linkApi)
            .then(response =>{
                setError(false);
                setData(response.data)
                //console.log(response.data)
            }).catch(error=>{
                console.log(error);
                console.log("error de api")
                setError(true);
            })
        }else
            //console.log("error de input" + input)
            setError(true);

    }
    return (
        <div>
            <NavBar/>
            <div className="jumbotron bg-dark clima-bg rounded-0 my-0">
                
                <div className="container text-center ">
                    <h1 className="text-white mb-3">Consulta el clima</h1>
                    <label htmlFor="city" className="text-white mb-3">Ciudad:</label>
                    <div className = "mb-3 d-flex justify-content-center">
                        <input type="text" className="form-control w-50 " onChange  = {HandleChange} placeholder="Ej. México city"/>
                    </div>
                    <button onClick = {()=>ApiConection()}  className="btn custom-btn mt-4">
                        Buscar
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                    
                    {error === false?
                        <>
                        {data !== null && 
                        <div className="mt-5  d-flex justify-content-center">
                            <Alert className = "w-50" variant = "info" >
                                {"Weather in " + data.name + " is " + data.weather[0].description}
                                <br/>
                                {"Temperature : " + (data.main.temp - 273.15).toFixed(2) + "℃"}
                                <br/>
                                {"Feels like: " + (data.main.feels_like - 273.15).toFixed(2) + "℃"}
                                <br/>
                                {"Max: " + (data.main.temp_max - 273.15).toFixed(2) + "℃"}
                                <br/>
                                {"Min: " + (data.main.temp_min - 273.15).toFixed(2) + "℃"}
                                <br/>
                                {"Humidity: " + data.main.humidity  + "%"}
                                <br/>
                                {"Pressure: " + data.main.pressure  + " hPa"}
                                <br/>
                                
                                
                            </Alert>
                            
                        </div>
                    }
                        </>
                        :
                        <div className="mt-5  d-flex justify-content-center">
                            <Alert variant = "danger" >
                            Error: Revisa la ciudad ingresada
                            </Alert>
                        </div> 
                        
                    }
                    
                </div>
            </div>
            <Footer/>
        </div>
    )
}
export default Clima